import { modifyAndLoadServiceAvail } from "../../../../actions/serviceActions"

const submit = async (values, dispatch) => {
  await dispatch(modifyAndLoadServiceAvail(values.id, values.availability))
}

export default submit